import {
	Breakpoints,
	InteractionLayer,
	LayerWrapper,
	styled,
	ThemeName,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import {
	InteractionLayerSizeV2,
	LayerHandleV2,
	LayerManagerV2,
	ShimBackgroundTypeV2,
} from '@volkswagen-onehub/layer-manager';
import React, { useContext, useEffect, useRef, useState } from 'react';
import {
	OfertasContext,
	useFeatureServices,
} from '../../context/ofertas-context';

export enum Gradient {
	LINEAR_GRADIENT_RIGHT = 'linear-gradient(270deg, #00437a 0%, #001e50 100%)',
}

const InteractionDiv = styled.div<{ gradientType?: Gradient }>`
	& > div {
		background-image: ${(props) => props.gradientType};

		@media (max-width: ${Breakpoints.b960}px) {
			width: 100%;
			height: 100%;
		}
	}
`;

export const ContentLayer: React.FC<{
	children: React.ReactElement;
	theme?: ThemeName;
	gradientType?: Gradient;
	layerSize: InteractionLayerSizeV2;
	isLayerVisible: boolean;
	className: string;
}> = ({ children, theme, gradientType, layerSize, isLayerVisible }) => {
	const ofertasContext = useContext(OfertasContext);
	const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
	const layerRef = useRef<LayerHandleV2<any>>(null);

	const [isShimLayerActive, setIsShimLayerActive] = useState(true);

	useEffect(() => {
		setIsShimLayerActive(true);
	}, []);

	const renderOfertaLayer = () => {
		return (
			<OfertasContext.Provider value={ofertasContext}>
				{isShimLayerActive && (
					<LayerWrapper contentCentered>
						<InteractionDiv
							gradientType={gradientType}
							className="interaction-div"
						>
							<InteractionLayer
								ariaLabel="interaction-layer"
								size={layerSize}
								active
							>
								<ThemeProvider theme={theme ? theme : 'inverted'}>
									{React.cloneElement(children, { layerRef })}
								</ThemeProvider>
							</InteractionLayer>
						</InteractionDiv>
					</LayerWrapper>
				)}
			</OfertasContext.Provider>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!layerRef.current && isLayerVisible) {
			const layer = layerManager.openInteractionLayer(
				renderOfertaLayer,
				{},
				{
					size: layerSize,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			layerRef.current = layer;
		}
		return null;
	};

	return <>{isLayerVisible && renderInteractionLayer()}</>;
};
